import { createFileRoute } from '@tanstack/react-router'

import { PromotionsPage } from '#/modules/promotions/promotions-page'
import { validateListSearch } from '#/shared/lib/list-search'

export const Route = createFileRoute('/_shell/promotions')({
  component: PromotionsPage,
  validateSearch: validateListSearch,
})
